import { TableCell } from '@mui/material';
import { BaseTableCellProps } from './BaseTableCell.types';

/**
 * The base MUI TableCell used as an entry point and as separation for mocking.
 *
 * @param classes - {@link BaseTableCellProps.classes classes} description.
 * @param sx - {@link BaseTableCellProps.sx sx} description.
 * @param children - {@link BaseTableCellProps.children children} description.
 */
export const BaseTableCell = ({
    classes,
    sx,
    children,
}: BaseTableCellProps) => {
    return (
        <TableCell
            classes={{
                ...classes,
            }}
            sx={{
                ...sx,
            }}
        >
            {children}
        </TableCell>
    );
};